<script setup>
import { onMounted, reactive } from 'vue'
import Multiselect from '@vueform/multiselect'
import axios from 'axios'

const props = defineProps([
    'name',
    'placeholderProp',
    'route',
    'val',
    'noResultsText',
    'type',
    'city',
    'zip'
])

onMounted( () => {
    if ( props.city && props.zip ) {
        state.placeholder = props.city + ', ' + props.zip
        document.getElementById(`${props.type}-city`).setAttribute('value', props.city)
        document.getElementById(`${props.type}-zip`).setAttribute('value', props.zip)
        document.getElementById(`${props.type}-city-zip-id`).setAttribute('value', props.val)
    }
})

const state = reactive({
    value: props.val,
    minChars: 2,
    multiselect: null,
    placeholder: props.placeholderProp,
    options: null,
    q: ''
})

const fetchData = async (query, select) => {
    console.log('fetching')

    if ( query.length >= state.minChars ) {
        const response = await axios.get(`${props.route}/${query}`)

        const data = await response.data

        if ( query.length ) {

            return data.data.map( (item) => {
                return { value: item.id, zip: item.zip, city: item.city, label: item.city_zip }
            })
        }
    }
}

const handleSelectedOption = (value, option) => {
    document.getElementById(`${props.type}-city`).setAttribute('value', option.city)
    document.getElementById(`${props.type}-zip`).setAttribute('value', option.zip)
    document.getElementById(`${props.type}-city-zip-id`).setAttribute('value', state.value)
}
</script>

<template>
      <Multiselect
            :class="{ 'filled': city.length && zip.length }"
            :name="name"
            v-model="state.value"
            :placeholder="state.placeholder"
            :searchable="true"
            :filter-results="false"
            :delay="700"
            :min-chars="state.minChars"
            :resolve-on-load="false"
            :no-options-text="noResultsText"
            @keyup="fetchData"
            @select="handleSelectedOption"
            :options="async function(query, select$) {
                return await fetchData(query, select$)
            }"
            ref="multiselect"
        >

        <template v-slot:singlelabel="{ value }">
            <div class="multiselect-multiple-label">
                {{ value.label }}
            </div>
        </template>

    </Multiselect>

    <input type="hidden" :name="name" :id="type + '-city-zip-id'">
    <input type="hidden" :name="type + '[city]'" :id="type + '-city'">
    <input type="hidden" :name="type+'[zip]'" :id="type + '-zip'">
</template>

<style src="@vueform/multiselect/themes/default.css"></style>
